var css = {"overlay":"ModalBase-module_overlay__LFkic","fadeIn":"ModalBase-module_fadeIn__08gc7"};

export { css as default };
